import { styled } from '$utils/theme'
import { rem } from 'polished'
import { Block } from '$views/components'

export const SelectWrapper = styled(Block).attrs({})<{ width: number; bordered: boolean }>`
  width: ${p => p.width}% !important;
  position: relative;
  float: left;
  border: solid 1px ${p => (p.bordered === true ? p.theme.colors.darkGrey : p.theme.colors.lightGrey)};
  border-radius: 1.5625rem 1.5625rem;
  background-color: #fff;
  &:hover {
    cursor: pointer;
  }
  &:active {
    border-color: ${p => p.theme.colors.darkGrey};
    border-radius: 1.5625rem 1.5625rem 0 0;
  }
`

export const StyledSelect = styled.select`
  color: ${p => (p.value === '' ? '#aeaeae' : p.theme.colors.darkGrey)};
  width: 100%;
  height: 3rem;
  border: none;
  background-color: #ffffff00;
  line-height: 1rem;
  padding: 1rem;
  outline: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-appearance: none;
  cursor: pointer;

  font-size: ${p => rem(p.theme.sizes.mini)};
`

export const StyledOption = styled.option.attrs({})<{ isPLaceholder: boolean }>`
  box-sizing: border-box;
  color: ${p => (p.isPLaceholder ? '#aeaeae' : p.theme.colors.darkGrey)};
  cursor: pointer;
  display: block;
  padding: 8px 10px;
  opacity: 1;

  &:checked {
    background-color: #e1eff2;
  }

  font-size: ${p => rem(p.theme.sizes.mini)};
`

export const Arrow = styled.span`
  border-color: ${p => p.theme.colors.darkGrey};
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  content: ' ';
  display: inline-block;
  margin-top: -ceil(2.5);
  position: absolute;
  right: 21px;
  top: 18px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);

  ${SelectWrapper}:active & {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }
`



// WEBPACK FOOTER //
// ./src/views/components/NativeSelect/NativeSelect.style.ts